import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext';
import { hasExternalAccountSession, shouldRedirectToExternalSignup } from '../auth/useExternalMsal';
import { savePostLoginRedirect } from '../utils/postLoginRedirect';

export const PrivateRoute = ({ children }: any) => {
    const { loggedInUser } = useAuthStore();
    const location = useLocation();
    const shouldUseExternalSignup = shouldRedirectToExternalSignup();

    if (!loggedInUser) {
        if (shouldUseExternalSignup) {
            return <Navigate to="/signup" replace />;
        }
        if (!hasExternalAccountSession()) {
            savePostLoginRedirect(location.pathname, location.search);
        }
        return <Navigate to="/login" replace />;
    }

    return children;
};
